// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PqzGbX41QQwA272Mbk_6 {
	align-items: center;
	background-color: var(--gray);
	border-radius: 8px;
	display: flex;
	padding: 4px;
}

.PqzGbX41QQwA272Mbk_6 > *:not(:last-child) {
		margin-right: 4px;
	}

.WPszyZLa4OODl5Sdecof {
	align-items: center;
	background-color: var(--white);
	border-radius: 8px;
	display: flex;
	flex: 1;
	justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CrossChainFarmPageV2/FarmDetails/Tokens/Tokens.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,6BAA6B;CAC7B,kBAAkB;CAClB,aAAa;CACb,YAAY;AAKb;;AAHC;EACC,iBAAiB;CAClB;;AAGD;CACC,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;CAClB,aAAa;CACb,OAAO;CACP,uBAAuB;AACxB","sourcesContent":[".container {\n\talign-items: center;\n\tbackground-color: var(--gray);\n\tborder-radius: 8px;\n\tdisplay: flex;\n\tpadding: 4px;\n\n\t& > *:not(:last-child) {\n\t\tmargin-right: 4px;\n\t}\n}\n\n.assetContainer {\n\talign-items: center;\n\tbackground-color: var(--white);\n\tborder-radius: 8px;\n\tdisplay: flex;\n\tflex: 1;\n\tjustify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PqzGbX41QQwA272Mbk_6`,
	"assetContainer": `WPszyZLa4OODl5Sdecof`
};
export default ___CSS_LOADER_EXPORT___;
